<div *ngIf="inputForm">
  <form [formGroup]="inputForm">
    <ng-container *ngIf="producers$ | async as producers">
      <section *ngIf="!!producers.length">
        <h3>
          MaStR-Nummern der Erzeugungseinheiten
          <app-tooltip-icon [info]="'(beginnt mit SEE , Bsp. SEE123456789012)'"></app-tooltip-icon>
        </h3>
        <form-row *ngFor="let item of producers; let itemIndex = index; first as isFirst; last as isLast">
          <mat-label>Von {{ item.manufacturer }} - {{ item.deviceTypeName }}</mat-label>
        </form-row>
        <form-row>
          <mat-form-field appearance="outline" name="maStRNumberProducer" fxFlex>
            <mat-label>MaStR-Nummern der Erzeugungseinheiten</mat-label>
            <input
              matInput
              type="text"
              formControlName="maStRNumberProducer"
              (input)="
                inputForm
                  .get('maStRNumberProducer')
                  .setValue(inputForm.get('maStRNumberProducer').value.toUpperCase())
              " />
            <mat-error *ngIf="inputForm.get('maStRNumberProducer').hasError('required')">
              Das Feld ist erforderlich
            </mat-error>
            <mat-error *ngIf="inputForm.get('maStRNumberProducer').hasError('pattern')">
              MaStR-Nummern der Erzeugungseinheiten besteht aus einem „SEE“ plus 12 Zeichen
            </mat-error>
          </mat-form-field>
        </form-row>

        <app-tenant-config-proxy
          [configPath]="
            'gridRegistration.mastrValidationConfig.enableMastrValidationForPlaceInServiceRequest'
          ">
          <app-default-card
            [title]="'Vergleich zum Marktstammdatenregister'"
            *ngIf="inputForm.controls.maStRNumberProducer && (model$ | async) as mastrModel">
            <app-mastr-validation
              [grData]="mastrModel"
              [mastrNumber]="maStRNumberProducer$ | async"
              (mastrDataMismatchFields)="mastrDataMismatchFields.emit($event)" />
          </app-default-card>
        </app-tenant-config-proxy>

        <div *ngIf="showAdditionalMastrFields">
          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR-SEL-Nummer der Stromerzeugungslokation der Einheit</mat-label>
              <input matInput type="text" formControlName="maStRSELNumber" />
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR-EEG-Nummer der Erzeugungseinheit</mat-label>
              <input matInput type="text" formControlName="maStREEGNumber" />
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR Nutzungsart der Lokation</mat-label>
              <mat-select formControlName="usageType">
                <mat-option *ngFor="let ele of metaService.usageTypes$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR Ausrichtung der Anlage</mat-label>
              <mat-select formControlName="orientation">
                <mat-option *ngFor="let ele of metaService.orientationValues$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR Neigung der Anlage</mat-label>
              <mat-select formControlName="tilt">
                <mat-option *ngFor="let ele of metaService.tiltValues$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR Neben-Ausrichtung der Anlage</mat-label>
              <mat-select formControlName="secondaryOrientation">
                <mat-option *ngFor="let ele of metaService.orientationValues$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR Neben-Neigung der Anlage</mat-label>
              <mat-select formControlName="secondaryTilt">
                <mat-option *ngFor="let ele of metaService.tiltValues$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>
        </div>
        -
      </section>
    </ng-container>
    <ng-container *ngIf="storages$ | async as storages">
      <section *ngIf="!!storages.length">
        <h3>
          MaStR-Nr der Speichereinheit
          <app-tooltip-icon [info]="'(beginnt mit SEE , Bsp. SEE123456789012)'"></app-tooltip-icon>
        </h3>
        <form-row *ngFor="let item of storages; let itemIndex = index; first as isFirst; last as isLast">
          <mat-label>Von {{ item.manufacturer }} - {{ item.deviceTypeName }}</mat-label>
        </form-row>
        <form-row>
          <mat-form-field appearance="outline" name="maStRNumberStorage" fxFlex>
            <mat-label>MaStR-Nummern der Speichereinheit</mat-label>
            <input
              matInput
              type="text"
              formControlName="maStRNumberStorage"
              (input)="
                inputForm
                  .get('maStRNumberStorage')
                  .setValue(inputForm.get('maStRNumberStorage').value.toUpperCase())
              " />
            <mat-error *ngIf="inputForm.get('maStRNumberStorage').hasError('required')">
              Das Feld ist erforderlich
            </mat-error>
            <mat-error *ngIf="inputForm.get('maStRNumberStorage').hasError('pattern')">
              MaStR-Nummern der Speichereinheit besteht aus einem „SEE“ plus 12 Zeichen
            </mat-error>
          </mat-form-field>
        </form-row>

        <div *ngIf="showAdditionalMastrFields">
          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR-SSE-Nummer der Speichereinheit</mat-label>
              <input
                matInput
                type="text"
                formControlName="maStRSSENumberStorage"
                (input)="
                  inputForm
                    .get('maStRSSENumberStorage')
                    .setValue(inputForm.get('maStRSSENumberStorage').value.toUpperCase())
                " />
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>MaStR-EEG-Nummer der Speichereinheit</mat-label>
              <input
                matInput
                type="text"
                formControlName="maStREEGNumberStorage"
                (input)="
                  inputForm
                    .get('maStREEGNumberStorage')
                    .setValue(inputForm.get('maStREEGNumberStorage').value.toUpperCase())
                " />
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Batterietechnologie</mat-label>
              <mat-select formControlName="batteryTechnology">
                <mat-option *ngFor="let ele of metaService.batteryTechnology$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>

          <form-row>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Batterietyp</mat-label>
              <mat-select formControlName="batteryType">
                <mat-option *ngFor="let ele of metaService.batteryType$ | async" [value]="ele.value">
                  {{ ele.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form-row>
        </div>
      </section>
    </ng-container>
    <section>
      <h3 fxLayout="row" fxLayoutAlign="start center" fxLayoutGap=".5em">
        <span>MaStR-Nr des Anlagenbetreibers der Einheit</span>
        <app-tooltip-icon [info]="'(beginnt mit ABR, Bsp. ABR123456789012)'"></app-tooltip-icon>
      </h3>
      <form-row>
        <mat-form-field appearance="outline" name="maStRNumber" fxFlex>
          <mat-label>MaStR-Nr des Anlagenbetreibers der Einheit</mat-label>
          <input
            matInput
            type="text"
            formControlName="maStRNumber"
            (input)="
              inputForm.get('maStRNumber').setValue(inputForm.get('maStRNumber').value.toUpperCase())
            " />
          <mat-error *ngIf="inputForm.get('maStRNumber').hasError('required')">
            Das Feld ist erforderlich
          </mat-error>
          <mat-error *ngIf="inputForm.get('maStRNumber').hasError('pattern')">
            MaStR-Nr des Anlagenbetreibers der Einheit besteht aus einem „ABR“ plus 12 Zeichen
          </mat-error>
        </mat-form-field>
      </form-row>
    </section>

    <section *ngIf="!isInstaller">
      <form-row>
        <app-accept-conditions
          [inputForm]="inputForm"
          [controlName]="'maStRAcceptedDeclaration'"
          [disable]="disableConditions"
          [inputLink]=""
          [inputText]="
            'Hiermit erkläre(n) ich / wir, dass ich / wir die oben genannten Anlagen nach Vorgaben der Anlagen- bzw. Marktstammdatenregisterverordnung im Anlagen- bzw. Marktstammdatenregister bei der Bundesnetzagentur registriert habe(n).<br/>' +
            'Eine spätere Änderung der installierten Leistung ist auch an das Anlagenregister zu übermitteln und dem Netz- betreiber schriftlich mitzuteilen.'
          "></app-accept-conditions>
      </form-row>
    </section>

    <section>
      <form-row>
        <mat-form-field appearance="outline">
          <mat-label>Datum der Registrierung:</mat-label>
          <input
            matInput
            formControlName="maStRRegistrationDate"
            [matDatepicker]="register"
            placeholder="Datum der Registrierung" />
          <mat-datepicker-toggle matSuffix [for]="register"></mat-datepicker-toggle>
          <mat-datepicker #register></mat-datepicker>
        </mat-form-field>
      </form-row>
    </section>
  </form>
</div>
